import CollectionList from '@/components/component/Reuse/CollectionList/CollectionList.vue'
import pageRoute from '@/libs/constant/pageRoutes'

export default {
    name: 'TeamsCollection',
    components: {CollectionList},
    computed: {
        isDossier () {
            let isTrue = false
            if (this.$route.name === pageRoute.organisationDossiers) isTrue = true
            return isTrue
        }
    },
    methods: {
        /**
         * route to article page of collection or dossier
         */
        routeToArticlePage (list) {
            if (this.isDossier) this.$router.push({name: pageRoute.organisationDossierPage, params: {cid: list._id}})
            else this.$router.push({name: pageRoute.organisationCollectionPage, params: {cid: list._id}})
        }
    }
}